
import {Component, Vue} from 'vue-property-decorator';
import { ScreenDocumentFlat, ScreenToyDocument } from '@/models/screen.model';
import SbScreenStorePanel from '@/components/stead/workspaces/stepbuilder/dialogboxes/sbScreenStorePanel.vue';
import SbScreenToysPanel from "@/components/stead/workspaces/stepbuilder/dialogboxes/sbScreenToysPanel.vue";

@Component({
  components: {SbScreenToysPanel, SbScreenStorePanel}
})
export default class sbSelectToyDialog extends Vue {
  // Les props
  // Les propriétés
  private screenData: ScreenDocumentFlat | null = null
  private isVisible: boolean = false

  // Les propriétés calculées
  // Les hooks
  // Les méthodes surveillées
  // Les méthodes d'instance
  private onClose() {
    this.$emit('cancel')
    this.isVisible = false
  }

  private onSelectToy(toy: ScreenToyDocument) {
    // console.log('SelectToy - emit toy', toy)
    this.$emit('toy', toy)
  }

  // Les méthodes statiques
}
